<template>
  <v-text-field
          ref="text"
          persistent-hint
          class="kanban-section-input"
          v-model="text"
          @blur="ok( text )"
  ></v-text-field>
</template>

<script>

export default {

  name: 'DSectionMiniEditor',

  componentName: "DSectionMiniEditor",

  /**
   *
   *
   */
  props: {

    name: {
      type: String,
      required: false
    },
  },

  /**
   *
   *
   */
  mounted() {

    this.$refs.text.focus()
  },

  /**
   *
   *
   */
  data() {

    return {

      text: ''
    }
  },

  /**
   *
   *
   */
  watch: {

    name: {

      handler( name ) {

        this.text = name
      },

      immediate: true
    }
  },

  /**
   *
   *
   */
  computed: {

  },

  /**
   *
   *
   */
  methods: {

    /**
     *
     *
     */
    ok( name ) {

      this.$emit( 'ok', name )
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/DKanban/src/DSectionMiniEditor.vue